import NewHome from "../contents/home/NewHome";

// 게시판 메뉴
import BoardLayout from "../contents/common/board/BoardLayout";

// 관리자 메뉴
import UserMng from "../contents/manager/user_mng/UserMng";
import AuditLog from "../contents/manager/AuditLog";
import ExcelDownLog from "../contents/manager/ExcelDownLog";
import RoleMng from "../contents/manager/role_mng/RoleMng";
import RoleMenuMng from "../contents/manager/role_mng/RoleMenuMng";

// Agent 관리
import NewOrgDetail from "../contents/manager/org_mng/NewOrgDetail";
import NewOrgParticipate from "../contents/manager/org_mng/NewOrgParticipate";

// NEDIS 시스템관리
import BdExceptTrans from "../contents/manager/nedis_mng/BdExceptTrans";
import BdExceptionApp from "../contents/manager/nedis_mng/BdExceptionApp";

// 표준
import BdJrNaeyeokListA from "../contents/ptmi/01_ptmiinfo/BdJrNaeyeokListA";
// import BdJrNaeyeokDetailListA from "../contents/ptmi/01_ptmiinfo/bdjrnaeyeokdetaillistA/BdJrNaeyeokDetailListA";
import BdJrNaeyeokDetailListA from "../contents/ptmi/01_ptmiinfo/bdjrnaeyeokdetaillistA/BdJrNaeyeokDetailListANew";
import BdTrcdDiagList from "../contents/ptmi/01_ptmiinfo/BdTrcdDiagList";
import NotConnectReasonList from "../contents/ptmi/01_ptmiinfo/notconnectreasonlist/NotConnectReasonList";

import BdMisang from "../contents/ptmi/02_datacheck/BdMisang";
import BdErrList from "../contents/ptmi/02_datacheck/BdErrList";
import BdAnalyze from "../contents/ptmi/02_datacheck/BdAnalyze";
import BdRegumtoList from "../contents/ptmi/02_datacheck/BdRegumtoList";

import BdExceptionAsk from '../contents/ptmi/03_exception/BdExceptionAsk';
import BdExceptionList from '../contents/ptmi/03_exception/BdExceptionList';

import SendStatMonthly2016 from "../contents/ptmi/04_fidelity/SendStatMonthly2016";
import CompSendStatMonthly from "../contents/ptmi/04_fidelity/CompSendStatMonthly";
import CompSendStatQuarterly from "../contents/ptmi/04_fidelity/CompSendStatQuarterly";
import SendStatMonitoring2016 from "../contents/ptmi/04_fidelity/SendStatMonitoring2016";
import InfoMngStatMonthly from "../contents/ptmi/04_fidelity/InfoMngStatMonthly";
import CompInfoMngStatMonthly from "../contents/ptmi/04_fidelity/CompInfoMngStatMonthly";
import CompInfoMngStatQuarterly from "../contents/ptmi/04_fidelity/CompInfoMngStatQuarterly";
import SendHistoryMonthly from "../contents/ptmi/04_fidelity/SendHistoryMonthly";
import SendStatMonitoringMsgData from "../contents/ptmi/04_fidelity/SendStatMonitoringMsgData";
import TrmsSample from "../contents/trms/Sample";

import BdTongFieldin from "../contents/ptmi/05_monitoring/BdTongFieldin";
import BdTongtFieldin from "../contents/ptmi/05_monitoring/BdTongtFieldin";
import BdTongDayin from "../contents/ptmi/05_monitoring/BdTongDayin";
import BdTongmFieldin from "../contents/ptmi/05_monitoring/BdTongmFieldin";
import BdTongChongipryukryul from "../contents/ptmi/05_monitoring/BdTongChongipryukryul";

import CheckInfoList from "../contents/ptmi/06_datachecksheet_nedis/CheckInfoList";

import BdTongAgesexx from "../contents/ptmi/08_patient_statis/BdTongAgesexx";
import BdTongBohum from "../contents/ptmi/08_patient_statis/BdTongBohum";
import BdTongNwmonth from "../contents/ptmi/08_patient_statis/BdTongNwmonth";
import BdTongNwday from "../contents/ptmi/08_patient_statis/BdTongNwday";
import BdTongIntm from "../contents/ptmi/08_patient_statis/BdTongIntm";
import BdTongArcfarcs from "../contents/ptmi/08_patient_statis/BdTongArcfarcs";

import BdTongEmsy from "../contents/ptmi/09_hosp_bef_statis/BdTongEmsy";
import BdTongNwroute from "../contents/ptmi/09_hosp_bef_statis/BdTongNwroute";
import BdTongAgeGugubcha from "../contents/ptmi/09_hosp_bef_statis/BdTongAgeGugubcha";
import BdTongeBalByungNaeWonSiGan from "../contents/ptmi/09_hosp_bef_statis/BdTongeBalByungNaeWonSiGan";

import BdTongeMstay from "../contents/ptmi/10_hosp_aft_statis/BdTongeMstay";
import BdTongeMstayLength from "../contents/ptmi/10_hosp_aft_statis/BdTongeMstayLength";
import BdTongeIpWonBunSuck from "../contents/ptmi/10_hosp_aft_statis/BdTongeIpWonBunSuck";
import BdTongeSusulBunSuck from "../contents/ptmi/10_hosp_aft_statis/BdTongeSusulBunSuck";
import BdTongeSaManglBunSuck from "../contents/ptmi/10_hosp_aft_statis/BdTongeSaManglBunSuck";
import BdTongeMrta from "../contents/ptmi/10_hosp_aft_statis/BdTongeMrta";
import BdTongeMrtr from "../contents/ptmi/10_hosp_aft_statis/BdTongeMrtr";
import BdTongIpWonJaeSil from "../contents/ptmi/10_hosp_aft_statis/BdTongIpWonJaeSil";
import BdTongYoung from "../contents/ptmi/10_hosp_aft_statis/BdTongYoung";
import BdTongAvgZaeSil from "../contents/ptmi/10_hosp_aft_statis/BdTongAvgZaeSil";

import BdTongeJunWonSaYu from "../contents/ptmi/11_hosp_trans_statis/BdTongeJunWonSaYu";
import BdTongeJunWonSaYuJaeJunWon from "../contents/ptmi/11_hosp_trans_statis/BdTongeJunWonSaYuJaeJunWon";
import BdTonge119JaeJunWon from "../contents/ptmi/11_hosp_trans_statis/BdTonge119JaeJunWon";

import BdTongQsypt from "../contents/ptmi/12_treat_analysis/BdTongQsypt";
import BdTongQtrpt from "../contents/ptmi/12_treat_analysis/BdTongQtrpt";
import BdTongQdgot from "../contents/ptmi/12_treat_analysis/BdTongQdgot";
import BdTongQdgdc from "../contents/ptmi/12_treat_analysis/BdTongQdgdc";
import BdTongQoppt from "../contents/ptmi/12_treat_analysis/BdTongQoppt";

import BdTongJunSungHyunHwang from "../contents/ptmi/13_current_trans/BdTongJunSungHyunHwang";
import BdTongJunSungSummary from "../contents/ptmi/13_current_trans/BdTongJunSungSummary";
import BdTongMenuSaYoung from "../contents/ptmi/13_current_trans/BdTongMenuSaYoung";

//외상
import OesangWeb from "../contents/trms/01_trmsinfo/OesangWeb";
import TrmsNaeyeokV3 from "../contents/trms/01_trmsinfo/TrmsNaeyeokV3";
import TrmsNaeyeokV2 from "../contents/trms/01_trmsinfo/TrmsNaeyeokV2";

//02
import BdErrListTrms from "../contents/trms/02_datacheck_trms/BdErrListTrms";
import BdRegumtoListTrms from "../contents/trms/02_datacheck_trms/BdRegumtoListTrms";
import BdMisangListTrms from "../contents/trms/02_datacheck_trms/BdMisangListTrms";
import BdTrmsMiwan from "../contents/trms/02_datacheck_trms/BdTrmsMiwan";

//03
import OEBdExceptionList from "../contents/trms/03_exception_trms/OEBdExceptionList";
import OEBdExceptionAsk from "../contents/trms/03_exception_trms/OEBdExceptionAsk";

//04
import BdTongTrmsStatDataTransferRateNew from "../contents/trms/04_monitoring_trms/BdTongTrmsStatDataTransferRateNew";
import BdTongTrmsStatDataTransferRate from "../contents/trms/04_monitoring_trms/BdTongTrmsStatDataTransferRate";
import BdTongTrmsEmogExceptCodeRate from "../contents/trms/04_monitoring_trms/BdTongTrmsEmogExceptCodeRate";
import BdTongTrmsStatSeriousIllnessInputRate from "../contents/trms/04_monitoring_trms/BdTongTrmsStatSeriousIllnessInputRate";

//05
import FidelityTargetManage from "../contents/trms/05_fidelity_trms/fidelityTargetManage";
import FidelityInputStatic from "../contents/trms/05_fidelity_trms/FidelityInputStatic";
import FidelitySendStatic from "../contents/trms/05_fidelity_trms/FidelitySendStatic";
//06
import BdTongTrmsStatOfHospitalVisit from "../contents/trms/06_incurr_trms/BdTongTrmsStatOfHospitalVisit";

//07
import TrmsAgeGender from "../contents/trms/07_intype_trms/TrmsAgeGender";
import TrmsDamage from "../contents/trms/07_intype_trms/TrmsDamage";
import TrmsAccident from "../contents/trms/07_intype_trms/TrmsAccident";
import TrmsCourse from "../contents/trms/07_intype_trms/TrmsCourse";
import TrmsMeans from "../contents/trms/07_intype_trms/TrmsMeans";
import TrmsUseTime from "../contents/trms/07_intype_trms/TrmsUseTime";

//08
import TrmsCallArrival from "../contents/trms/08_trtinfo_trms/TrmsCallArrival";
import TrmsFirstVisit from "../contents/trms/08_trtinfo_trms/TrmsFirstVisit";
import TrmsMassTransfusion from "../contents/trms/08_trtinfo_trms/TrmsMassTransfusion";
import TrmsFinalCareDelivery from "../contents/trms/08_trtinfo_trms/TrmsFinalCareDelivery";
import TrmsEmrt from "../contents/trms/08_trtinfo_trms/TrmsEmrt";
import TrmsIcu from "../contents/trms/08_trtinfo_trms/TrmsIcu";
import TrmsDcrt from "../contents/trms/08_trtinfo_trms/TrmsDcrt";

//09
import OperRegAftDttbList from "../contents/trms/09_human_resource/OperRegAftDttbList";
import SportSpclstSttusList from "../contents/trms/09_human_resource/SportSpclstSttusList";
import BdTrmsHumanResource from "../contents/trms/09_human_resource/BdTrmsHumanResource";
import BdTrmsHumanNurse from "../contents/trms/09_human_resource/BdTrmsHumanNurse";
import BdTrmsHumanSpecial from "../contents/trms/09_human_resource/BdTrmsHumanSpecial";
import BdTrmsHumanSupport from "../contents/trms/09_human_resource/BdTrmsHumanSupport";
import BdTrmsHumanSNurse from "../contents/trms/09_human_resource/BdTrmsHumanSNurse";
import BdTrmsHumanEtc from "../contents/trms/09_human_resource/BdTrmsHumanEtc";
import BdTrmsDutyScheduled from "../contents/trms/09_human_resource/BdTrmsDutyScheduled";

//10
import OperRegList from "../contents/trms/10_operrslt_list/OperRegList";
import OperCmit from "../contents/trms/10_operrslt_list/OperCmit";
import ManageCmit from "../contents/trms/10_operrslt_list/ManageCmit";
import EdcTraing from "../contents/trms/10_operrslt_list/EdcTraing";
import CalamityTraing from "../contents/trms/10_operrslt_list/CalamityTraing";
import EcshgHnf from "../contents/trms/10_operrslt_list/EcshgHnf";
import EcshgHnfCalender from "../contents/trms/10_operrslt_list/EcshgHnfCalender";

//11
import OperRegTrnList from "../contents/trms/11_operrslt_trnlist/OperRegTrnList";
import TrnThesis from "../contents/trms/11_operrslt_trnlist/TrnThesis";
import TrnAbst from "../contents/trms/11_operrslt_trnlist/TrnAbst";
import OperCmitTrnList from "../contents/trms/11_operrslt_trnlist/OperCmitTrnList";
import EcshgHnfTrn from "../contents/trms/11_operrslt_trnlist/EcshgHnfTrn";
import TrnNote from "../contents/trms/11_operrslt_trnlist/TrnNote";

const Pages = [

    //home
    { path: '/', titlename: 'Home', comp: <NewHome /> },
    
    //board : 게시판 메뉴
    { path: '/board/notice_board.do/*', titlename: '공지사항', comp: <BoardLayout boardTypeCode={11} /> },
    { path: '/board/data_board.do/*', titlename: '자료실', comp: <BoardLayout boardTypeCode={3} /> },
    { path: '/board/business_board.do/*', titlename: '업무공유 게시판', comp: <BoardLayout boardTypeCode={14} /> },
    
    //manager : 관리자 메뉴
    { path: '/manager/user_mng.do', titlename: '사용자 관리', comp: <UserMng /> },
    { path: '/manager/audit_log.do', titlename: '감사로그', comp: <AuditLog /> },
    { path: '/manager/excel_down_log.do', titlename: '엑셀 다운로드 로그', comp: <ExcelDownLog /> },
    { path: '/manager/role_mng.do', titlename: '롤권한관리', comp: <RoleMng /> },
    { path: '/manager/role_menu_mng.do', titlename: '롤별메뉴접근관리', comp: <RoleMenuMng /> },
    
    //Agent 관리
    { path: '/org_mng/org_participate.do', titlename: 'Agent 관리', comp: <NewOrgDetail /> },
    { path: '/org_mng/org_participate.do/:emogcode', titlename: 'Agent 관리 - 참여사업 정보', comp: <NewOrgParticipate /> },

    //NEDIS 시스템관리 - 기본정보관리
    { path: '/system/nedis/codeweb/bdexceptrans.do', titlename: '전송기준 예외관리', comp: <BdExceptTrans /> },
    { path: '/system/nedis/sendweb/bdexception_app.do', titlename: '예외전송승인', comp: <BdExceptionApp /> },

    //ptmi : 표준
    //01_ptmiinfo - 표준정보조회
    { path: '/nedis/jinryoweb/bdjrnaeyeoklistA.do', titlename: '환자내역조회', comp: <BdJrNaeyeokListA /> },
    { path: '/nedis/jinryoweb/bdjrnaeyeokdetaillistA.do', titlename: '대상환자상세조회', comp: <BdJrNaeyeokDetailListA /> },
    { path: '/nedis/jinryoweb/bdtrcddiaglist.do', titlename: '검사/처치/수술 및 진단코드 조회', comp: <BdTrcdDiagList /> },
    { path: '/nedis/agent/notconnectreasonlist.do', titlename: 'NEDIS Agent 미 전송 사유 관리', comp: <NotConnectReasonList /> },


    //02_datacheck - 데이터 검토
    { path: '/nedis/gumtoweb/bdmisang.do', titlename: '미상데이터 분석', comp: <BdMisang /> },
    { path: '/nedis/gumtoweb/bderrlist.do', titlename: '오류내역 관리', comp: <BdErrList /> },
    { path: '/nedis/gumtoweb/bderranalyze.do', titlename: '오류데이터 분석', comp: <BdAnalyze /> },
    { path: '/nedis/gumtoweb/bdregumtolist.do', titlename: '재검토 내역 조회', comp: <BdRegumtoList /> },

    //03_exception - 예외전송관리
    { path: '/nedis/sendweb/bdexception_ask.do', titlename: '예외전송신청', comp: <BdExceptionAsk /> },
    { path: '/nedis/sendweb/bdexceptionlist.do', titlename: '예외전송 승인조회', comp: <BdExceptionList /> },

    //04_fidelity - 충실도 정보관리
    { path: '/nedis/fidelity_2016/send_stat_monthly.do', titlename: '월별전송내역', comp: <SendStatMonthly2016 /> },
    { path: '/nedis/fidelity/comp_send_stat_monthly.do', titlename: '월별전송내역 비교', comp: <CompSendStatMonthly /> },
    { path: '/nedis/fidelity/comp_send_stat_quarterly.do', titlename: '분기별전송내역 비교', comp: <CompSendStatQuarterly /> },
    { path: '/nedis/fidelity_2016/info_mng_stat_monthly.do', titlename: '월별정보관리내역', comp: <InfoMngStatMonthly /> },
    { path: '/nedis/fidelity/comp_info_mng_stat_monthly.do', titlename: '월별정보관리내역 비교', comp: <CompInfoMngStatMonthly /> },
    { path: '/nedis/fidelity/comp_info_mng_stat_quarterly.do', titlename: '분기별정보관리내역 비교', comp: <CompInfoMngStatQuarterly /> },
    { path: '/nedis/fidelity/send_history_monthly.do', titlename: '월별전송건수내역', comp: <SendHistoryMonthly /> },
    { path: '/nedis/fidelity_2016/send_stat_monitoring.do', titlename: '월별 모니터링', comp: <SendStatMonitoring2016 /> },
    { path: '/nedis/fidelity/send_stat_monitoring_msg_data.do', titlename: '월별 모니터링(정보관리 요청 내역)', comp: <SendStatMonitoringMsgData /> },

    //05_monitoring - 입력현황 모니터링
    { path: '/nedis/tonggyeweb/bdtongfieldin.do', titlename: '응급실정보 입력률', comp: <BdTongFieldin /> },
    { path: '/nedis/tonggyeweb/bdtongtfieldin.do', titlename: '입원후정보 입력률', comp: <BdTongtFieldin /> },
    { path: '/nedis/tonggyeweb/bdtongdayin.do', titlename: '일자별 입력률', comp: <BdTongDayin /> },
    { path: '/nedis/tonggyeweb/bdtongmfieldin.do', titlename: '항목별 월 입력률', comp: <BdTongmFieldin /> },
    { path: '/nedis/tonggyeweb/bdtongchongipryukryul.do', titlename: '총입력률', comp: <BdTongChongipryukryul /> },

    //06_datachecksheet_nedis - 정보전송 점검표(NEDIS)
    { path: '/medi_info/dashboards2/check_infolist.do', titlename: '정보전송 점검표(NEDIS)', comp: <CheckInfoList /> },

    //07_datachecksheet - 정보전송 점검표

    //08_patient_statis - 환자규모 및 특성현황 통계
    { path: '/nedis/tonggyeweb/bdtongagesexx.do', titlename: '연령별 내원환자수', comp: <BdTongAgesexx /> },
    { path: '/nedis/tonggyeweb/bdtongbohum.do', titlename: '보험유형별 환자수', comp: <BdTongBohum /> },
    { path: '/nedis/tonggyeweb/bdtongnwmonth.do', titlename: '내원월별 환자수', comp: <BdTongNwmonth /> },
    { path: '/nedis/tonggyeweb/bdtongnwday.do', titlename: '내원요일별 환자수', comp: <BdTongNwday /> },
    { path: '/nedis/tonggyeweb/bdtongintm.do', titlename: '내원시각별 환자수', comp: <BdTongIntm /> },
    { path: '/nedis/tonggyeweb/bdtongarcfarcs.do', titlename: '내원사유별 환자수', comp: <BdTongArcfarcs /> },

    //09_hosp_bef_statis - 병원전단계 통계
    { path: '/nedis/tonggyeweb/bdtongnwroute.do', titlename: '내원경로별 분석', comp: <BdTongNwroute /> },
    { path: '/nedis/tonggyeweb/bdtongemsy.do', titlename: '응급 비응급 환자분석', comp: <BdTongEmsy /> },
    { path: '/nedis/tonggyeweb/bdtongagegugubcha.do', titlename: '구급차 이용율', comp: <BdTongAgeGugubcha /> },
    { path: '/nedis/tonggyeweb/bdtongebalbyungnaewonsigan.do', titlename: '발병-내원 평균시간', comp: <BdTongeBalByungNaeWonSiGan /> },

    //10_hosp_aft_statis - 병원단계 통계
    { path: '/nedis/tonggyeweb/bdtongemstay.do', titlename: '진료결과별 평균재실시간', comp: <BdTongeMstay /> },
    { path: '/nedis/tonggyeweb/bdtongemstaylength.do', titlename: '재실시간별 환자분석', comp: <BdTongeMstayLength /> },
    { path: '/nedis/tonggyeweb/bdtongeipwonbunsuck.do', titlename: '내원환자 입원분석', comp: <BdTongeIpWonBunSuck /> },
    { path: '/nedis/tonggyeweb/bdtongesusulbunsuck.do', titlename: '내원환자 수술분석', comp: <BdTongeSusulBunSuck /> },
    { path: '/nedis/tonggyeweb/bdtongesamanglbunsuck.do', titlename: '내원환자 사망율분석', comp: <BdTongeSaManglBunSuck /> },
    { path: '/nedis/tonggyeweb/bdtongemrta.do', titlename: '응급실 진료결과', comp: <BdTongeMrta /> },
    { path: '/nedis/tonggyeweb/bdtongemrtr.do', titlename: '입원후 진료결과', comp: <BdTongeMrtr /> },
    { path: '/nedis/tonggyeweb/bdtongavgzaesil.do', titlename: '병상이용율', comp: <BdTongAvgZaeSil /> },
    { path: '/nedis/tonggyeweb/bdtongyoung.do', titlename: '소아환자분석', comp: <BdTongYoung /> },
    { path: '/nedis/tonggyeweb/bdtongipwonjaesil.do', titlename: '입원환자의 평균 응급실재실시간', comp: <BdTongIpWonJaeSil /> },

    //11_hosp_trans_statis - 병원간 이송단계 통계
    { path: '/nedis/tonggyeweb/bdtongejunwonsayu.do', titlename: '전원사유별 전원율', comp: <BdTongeJunWonSaYu /> },
    { path: '/nedis/tonggyeweb/bdtongejunwonsayujaejunwon.do', titlename: '전원환자의 재전원율', comp: <BdTongeJunWonSaYuJaeJunWon /> },
    { path: '/nedis/tonggyeweb/bdtonge119jaejunwon.do', titlename: '119이송환자의 전원율', comp: <BdTonge119JaeJunWon /> },

    //12_treat_analysis - 진료내역분석
    { path: '/nedis/tonggyeweb/bdtongqsypt.do', titlename: '다빈도 주증상', comp: <BdTongQsypt /> },
    { path: '/nedis/tonggyeweb/bdtongqtrpt.do', titlename: '다빈도 처치내역', comp: <BdTongQtrpt /> },
    { path: '/nedis/tonggyeweb/bdtongqdgot.do', titlename: '다빈도 퇴실시 진단', comp: <BdTongQdgot /> },
    { path: '/nedis/tonggyeweb/bdtongqdgdc.do', titlename: '다빈도 퇴원시 진단', comp: <BdTongQdgdc /> },
    { path: '/nedis/tonggyeweb/bdtongqoppt.do', titlename: '다빈도 수술내역', comp: <BdTongQoppt /> },

    //13_current_trans - 전송 및 이용현황
    { path: '/nedis/tonggyeweb/bdtongjunsunghyunhwang.do', titlename: '데이터전송현황', comp: <BdTongJunSungHyunHwang /> },
    { path: '/nedis/tonggyeweb/bdtongjunsungsummary.do', titlename: '전송일자별 전송횟수', comp: <BdTongJunSungSummary /> },
    { path: '/nedis/tonggyeweb/bdtongmenusayoung.do', titlename: '통계지표 이용율 분석', comp: <BdTongMenuSaYoung /> },

    //trms : 외상
    //01_trmsinfo - 표준정보조회(외상)
    { path: '/nedis/oesangweb2/bdtrms_init_b.do', titlename: '입력대상조회', comp: <OesangWeb /> },
    { path: '/nedis/oesangweb3/bdtrms_init.do', titlename: '외상환자조회 V3.0', comp: <TrmsNaeyeokV3 /> },
    { path: '/nedis/oesangweb2/bdtrms_init.do', titlename: '외상환자조회 V2.0', comp: <TrmsNaeyeokV2 /> },
    { path: '/nedis/oesangweb/bdtrmslist.do', titlename: '외상환자조회 V1.0', comp: <TrmsSample /> },

    //02_datacheck_trms - 데이터 검토(외상)
    { path: '/nedis/gumtoweb/bderrlist2.do', titlename: '오류내역 관리', comp: <BdErrListTrms /> },
    { path: '/nedis/gumtoweb/bdtrmsregumtolist.do', titlename: '재검토내역 관리', comp: <BdRegumtoListTrms /> },
    { path: '/nedis/gumtoweb/bdosmisang.do', titlename: '미상 데이터 분석', comp: <BdMisangListTrms /> },
    { path: '/nedis/gumtoweb/bdtrmsmiwan.do', titlename: '미완료 데이터 조회', comp: <BdTrmsMiwan /> },

    //03_exception_trms - 예외 전송 관리(외상)
    { path: '/nedis/oesendweb/OEbdexception_ask.do', titlename: '예외 전송 신청', comp: <OEBdExceptionAsk /> },
    { path: '/nedis/oesendweb/OEbdexceptionlist.do', titlename: '예외 전송 승인 조회', comp: <OEBdExceptionList /> },

    //04_monitoring_trms -  입력현황 모니터링(외상)
    { path: '/nedis/oetonggyeweb/bdtongtrms_stat_data_transfer_rate_new.do', titlename: '데이터 전송률 V2.0-V3.0', comp: <BdTongTrmsStatDataTransferRateNew /> },
    { path: '/nedis/oetonggyeweb/bdtongtrms_stat_data_transfer_rate.do', titlename: '데이터 전송률 V1.0', comp: <BdTongTrmsStatDataTransferRate /> },
    { path: '/nedis/oetonggyeweb/bdtongtrms_emog_except_code_rate.do', titlename: '외상환자 제외 현황', comp: <BdTongTrmsEmogExceptCodeRate /> },
    { path: '/nedis/oetonggyeweb/bdtongtrms_stat_serious_illness_input_rate.do', titlename: '중증도별 전송률 V2.0-V3.0', comp: <BdTongTrmsStatSeriousIllnessInputRate /> },

    //05_fidelity_trms - 외상 충실도 정보관리
    { path: '/nedis/oesangweb/fidelityTargetManage.do', titlename: '충실도 대상 관리', comp: <FidelityTargetManage /> },
    { path: '/nedis/oesangweb/fidelityInputStatic.do', titlename: '데이터 입력 현황', comp: <FidelityInputStatic /> },
    { path: '/nedis/oesangweb/fidelitySendStatic.do', titlename: '정보관리내역', comp: <FidelitySendStatic /> },

    //06_incurr_trms - 외상환자 내원현황
    { path: '/nedis/oetonggyeweb/bdtongtrms_stat_of_hospital_visit.do', titlename: '외상환자 내원현황', comp: <BdTongTrmsStatOfHospitalVisit /> },

    //07_intype_trms - 외상환자 내원유형
    { path: '/nedis/oetonggyeweb/bdtongtrms_stat_patient_age_gender.do', titlename: '연령별 현황', comp: <TrmsAgeGender /> },
    { path: '/nedis/oetonggyeweb/bdtongtrms_stat_damage.do', titlename: '손상유형별 현황', comp: <TrmsDamage /> },
    { path: '/nedis/oetonggyeweb/bdtongtrms_stat_accident.do', titlename: '사고종류별 현황', comp: <TrmsAccident /> },
    { path: '/nedis/oetonggyeweb/bdtongtrms_stat_course.do', titlename: '내원경로별 현황', comp: <TrmsCourse /> },
    { path: '/nedis/oetonggyeweb/bdtongtrms_stat_means.do', titlename: '내원수단별 현황', comp: <TrmsMeans /> },
    { path: '/nedis/oetonggyeweb/bdtongtrms_stat_to_come_hospital_use_time.do', titlename: '손상 후 내원 소요시간', comp: <TrmsUseTime /> },

    //08_trtinfo_trms - 외상환자 진료정보
    { path: '/nedis/oetonggyeweb/bdtongtrms_stat_to_call_arrival_use_time.do', titlename: '외상팀 활성화 소요시간', comp: <TrmsCallArrival /> },
    { path: '/nedis/oetonggyeweb/bdtongtrms_stat_to_first_visit_use_time.do', titlename: '외상팀 진료개시 소요시간', comp: <TrmsFirstVisit /> },
    { path: '/nedis/oetonggyeweb/bdtongtrms_stat_to_mass_transfusion_use_time.do', titlename: '대량수혈 개시 소요시간', comp: <TrmsMassTransfusion /> },
    { path: '/nedis/oetonggyeweb/bdtongtrms_stat_to_final_care_delivery_time.do', titlename: '재실시간', comp: <TrmsFinalCareDelivery /> },
    { path: '/nedis/oetonggyeweb/bdtongtrms_stat_emrt.do', titlename: '응급진료결과 현황', comp: <TrmsEmrt /> },
    { path: '/nedis/oetonggyeweb/bdtongtrms_stat_icu_time.do', titlename: '중환자실 재원시간', comp: <TrmsIcu /> },
    { path: '/nedis/oetonggyeweb/bdtongtrms_stat_dcrt.do', titlename: '입원 후 결과 현황', comp: <TrmsDcrt /> },

    //09_human_resource - 인력 관리
    { path: '/nedis/oesangbiz/operrsltRegAftDttbList.do', titlename: '등록일정관리', comp: <OperRegAftDttbList /> },
    { path: '/nedis/oesangweb/bdTrmsHumanResource.do', titlename: '전문의 인력 현황', comp: <BdTrmsHumanResource /> },
    { path: '/nedis/oesangbiz/ecshgSportSpclstSttusList.do', titlename: '전담전문의 과별 통계현황', comp: <SportSpclstSttusList /> },
    { path: '/nedis/oesangweb/bdTrmsHumanResource_nurse.do', titlename: '간호사 인력 현황', comp: <BdTrmsHumanNurse /> },
    { path: '/nedis/oesangweb/bdTrmsHumanResourceSpcial.do', titlename: '전담전문의 인력 현황', comp: <BdTrmsHumanSpecial /> },
    { path: '/nedis/oesangweb/bdTrmsHumanResourceSupport.do', titlename: '지원전문의 인력 현황', comp: <BdTrmsHumanSupport /> },
    { path: '/nedis/oesangweb/bdTrmsHumanNurse.do', titlename: '전담간호사 인력 현황', comp: <BdTrmsHumanSNurse /> },
    { path: '/nedis/oesangweb/bdTrmsHumanResourceEtc.do', titlename: '그 외 기타 인력 현황', comp: <BdTrmsHumanEtc /> },
    { path: '/nedis/oesangweb/bdTrmsDutySchedule.do', titlename: '외상센터 근무표 관리', comp: <BdTrmsDutyScheduled /> },

    //10_operrslt_list - 실적 관리
    { path: '/nedis/oesangbiz/operrsltRegList.do', titlename: '등록일정관리', comp: <OperRegList /> },
    { path: '/nedis/oesangbiz/opercmitOperrsltList.do', titlename: '운영위원회 운영 실적', comp: <OperCmit /> },
    { path: '/nedis/oesangbiz/trumaManageCmitOperrsList.do', titlename: '외상 질 관리 위원회 운영 실적 ', comp: <ManageCmit /> },
    { path: '/nedis/oesangbiz/areaEdcTraingRsltList.do', titlename: '지역 내 교육 및 훈련', comp: <EdcTraing /> },
    { path: '/nedis/oesangbiz/areaCalamityTraingRsltList.do', titlename: '지역 내 재난 훈련', comp: <CalamityTraing /> },
    { path: '/nedis/oesangbiz/ecshgHnfEdcTraingRsltList.do', titlename: '권역외상센터 교육 및 훈련', comp: <EcshgHnf /> },
    { path: '/nedis/oesangbiz/ecshgHnfEdcTraingRsltListCalender.do', titlename: '일정 공유', comp: <EcshgHnfCalender /> },

    //11_operrslt_trnlist - 수련기관 실적관리
    { path: '/nedis/oesangbiz/operrsltRegTrnList.do', titlename: '등록일정관리', comp: <OperRegTrnList /> },
    { path: '/nedis/oesangbiz/trnNote.do', titlename: '수련노트', comp: <TrnNote /> },
    { path: '/nedis/oesangbiz/trnThesis.do', titlename: '연구-논문', comp: <TrnThesis /> },
    { path: '/nedis/oesangbiz/trnAbstPst.do', titlename: '연구-초록 및 포스터', comp: <TrnAbst /> },
    { path: '/nedis/oesangbiz/opercmitOperrsltTrnList.do', titlename: '위원회 운영실적', comp: <OperCmitTrnList /> },
    { path: '/nedis/oesangbiz/ecshgHnfEdcTraingRsltTrnList.do', titlename: '교육 및 훈련', comp: <EcshgHnfTrn /> }
]

export default Pages;